export const getStaticAssetURL = (asset: string) => {
  return 'https://assets.update.ai' + asset.trim();
};
